import { configureStore } from "@reduxjs/toolkit";
import financingAuthReducer from "src/redux/slices/financingAuthSlice";

export const store = configureStore({
  reducer: {
    financingAuth: financingAuthReducer,
  },
});
